import { render, staticRenderFns } from "./BlockDevice.vue?vue&type=template&id=5bbd908a&"
import script from "./BlockDevice.vue?vue&type=script&lang=js&"
export * from "./BlockDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports